import type { Action } from 'redux'
import type { InvokeDefinition } from '../../signalr/types'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import { loadWindowSettings, loadWindowSettingsSuccess } from './actions'
import type { WindowSettingsDto } from './types'

export const loadWindowSettingsDefinition: InvokeDefinition<
  [],
  WindowSettingsDto,
  Action
> = {
  method: 'GetWindowSettings',
  strategy: 'switch',
  getParams,
  mapResponse: (settings) => [
    loadWindowSettings(settings),
    loadWindowSettingsSuccess(settings)
  ]
}
